// @ts-nocheck
import { CollateralHistoryTableOptions } from '@tassat/fred-extended-definitions';

import { CollateralHistoryAgGrid } from './collateralHistoryAgGrid';

export interface CollateralHistoryAgGridProps {
    tableOptions: CollateralHistoryTableOptions;
    setSelectedPledgeId: React.Dispatch<React.SetStateAction<string>>;
    overlayOpen?: boolean;
}

export default CollateralHistoryAgGrid;